import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Apify, ApifyFullScreenLoadingComponent } from '../Apify';
import { StockCard } from '../c/ChartCard';
import { T } from '../traks';

import SearchField from '../c/SearchField';
import { PortfolioExploreCard, StockExploreCard } from './Explore.js';
import AdSense from 'react-adsense';

const G = (props) => props.children;

var ExploreCPH = (props) => {
	var sections = [];

	var danish_banks=<T>Danish banks</T>;
	var danish_soccer=<T>Danish soccer clubs</T>;

	sections.push(
		<Row key="vndjcgfbiurgmj0i" className="align-items-center">
			<Col xs="12" className="pb-3">
				<h3 className="pt-4"><T>Danish collections</T></h3>
			</Col>
			<StockExploreCard ticker="OMXC25" exchange="IDX-DKK" card_img="/gfx/omxc25-350x136.svg" name="OMXC25" href="/portfolio/98"/>
			<PortfolioExploreCard id={242} card_img="/gfx/generic-bank-350x136-0.svg" name={danish_banks} href="/portfolio/242"/>
			<PortfolioExploreCard id={243} card_img="/gfx/soccer-ball-350x136-0.svg" name={danish_soccer} href="/portfolio/243"/>
			<Col xs="12" className="pb-3">
				<h3><T>Selected danish stocks</T></h3>
			</Col>
			<StockExploreCard ticker="CARLB-C" exchange="CPH" card_img="/gfx/carlsberg-350x136-0.svg" name="Carlsberg B" href="/ticker/CPH/CARLB-C"/>
			<StockExploreCard ticker="BIF-C" exchange="CPH" card_img="/gfx/brondby-if-350x136-0.svg" name="Brøndby IF" href="/ticker/CPH/BIF-C"/>
			<StockExploreCard ticker="MAERB-C" exchange="CPH" card_img="/gfx/maersk-350x136-1.svg" name="Maersk B" href="/ticker/CPH/MAERB-C"/>
			<StockExploreCard ticker="NSISB-C" exchange="CPH" card_img="/gfx/novozymes-350x136-0.svg" name="Novozymes" href="/ticker/CPH/NSISB-C"/>
			<StockExploreCard ticker="NOVOB-C" exchange="CPH" card_img="/gfx/novo-nordisk-350x136-1.svg" name="Novo Nordisk B" href="/ticker/CPH/NOVOB-C"/>
			<StockExploreCard ticker="RBREW-C" exchange="CPH" card_img="/gfx/unibrew-350x136-0.svg" name="Royal Unibrew" href="/ticker/CPH/RBREW-C"/>
			<StockExploreCard ticker="TRYG-C" exchange="CPH" card_img="/gfx/tryg-350x136-0.svg" name="Tryg" href="/ticker/CPH/TRYG-C"/>
			<StockExploreCard ticker="PNDOR-C" exchange="CPH" card_img="/gfx/pandora-350x136-0.svg" name="Pandora" href="/ticker/CPH/PNDOR-C"/>
			<StockExploreCard ticker="KBHL-C" exchange="CPH" card_img="/gfx/cph-350x136-0.svg" name="Copenhagen Airports" href="/ticker/CPH/KBHL-C"/>
			<Col sm="12" md="6" xl="4" className="pb-5 ad_troels_telefon_padding_fjern">
				<div style={{width:"350px", height:"250px"}}>
					<AdSense.Google
						client="ca-pub-7968086371323995"
						slot="2160011947"
						style={{display:"block"}}
						format="fluid"
						layoutKey="-6u+ey-3-56+9f"
					/>
				</div>
			</Col>
		</Row>

	);

	for (const section of props.home.Sections) {
		var items = [];

		const mk_stock_item = (asset) => {
			const key = `STOCK:${asset.Exchange}:${asset.Ticker}`;
			return (
				<Col key={key} md="3" className="pb-4">
					<StockCard
						exchange={asset.Exchange}
						ticker={asset.Ticker}
						range="3m"
					/>
				</Col>
			);
		};

		switch (section.Type) {
			case "STOCKS":
				items = section.Content.map(mk_stock_item);
				break;
			default:
				continue;
		}
		sections.push(
				<span key="SPANNING_ALL">
				<Row key={section.Type}>
					<Col xs="12" className="pb-3">
						<h3><T>Random danish stocks</T></h3>
					</Col>
				</Row>
				<Row>
					{items}
				</Row>
				</span>
		);
	}

	const placeholder = <T>Search danish assets</T>;

	return (
		<G>
			<div className="d-flex flex-column text-center ad_explore_large_img_cph justify-content-center">
				<div className="pt-5 text-white ad_explore_txt_header"><T>Denmark</T></div>
				<div className="text-white pb-3 ad_explore_txt_subheader px-2"><T>Explore assets exclusively from Denmark</T></div>
				<SearchField placeholder={placeholder} market="DK_STOCK" form_classes="justify-content-center pt-2" input_classes="ad_search_explore_page ad_no_outline_focus" input_id="search_field_1"/>
			</div>
			<Container>
				{sections}
			</Container>
		</G>
	);
}

ExploreCPH = Apify("/z/explore?market=DK_STOCK")
	.with_response_prop("home")
	.wrap(ExploreCPH, ApifyFullScreenLoadingComponent);

export default ExploreCPH;



// WEBPACK FOOTER //
// ./src/p/ExploreCPH.js